import React__default from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { SelectWrapper } from '../SelectWrapper/SelectWrapper.js';

const SelectQuantity = ({ id , isDisabled , maximumQuantity , onChange , packSize: packSize1 , quantity , showLabel , className  })=>{
    const { getLabel  } = useIntl();
    // helper to create the label options for the select box
    const createSelectOption = (boxAmount, packSize)=>{
        const label = `${packSize * boxAmount} ${getLabel('products.unit.contactLenses', {
            defaultValue: 'lenses'
        })}`;
        return `${boxAmount} (${label})`;
    };
    // create an array of length by maxmimumQuantity, fill it with options based on the index count
    const options1 = React__default.useMemo(()=>{
        return Array(maximumQuantity).fill(0).reduce((options, _, index)=>{
            const boxAmount = index + 1;
            const name = createSelectOption(boxAmount, packSize1);
            options[name] = boxAmount;
            return options;
        }, {});
    }, [
        maximumQuantity,
        packSize1
    ]);
    // prefill the selectbox if we have a quantity higher than 0.
    const optionKeys = Object.keys(options1);
    const initialSelection = quantity !== 0 ? {
        value: optionKeys[quantity - 1]
    } : {
        value: optionKeys[0]
    };
    const quantityLabel = getLabel('products.contactLenses.quantitySelect.label');
    const classnames$1 = classnames('select-quantity__select', className);
    return /*#__PURE__*/ React__default.createElement(SelectWrapper, null, showLabel && /*#__PURE__*/ React__default.createElement("label", {
        className: "select-quantity__label",
        htmlFor: id
    }, quantityLabel), /*#__PURE__*/ React__default.createElement(Select, {
        id: id,
        name: "quantity-selector",
        "aria-label": quantityLabel,
        className: classnames$1,
        options: options1,
        initialState: initialSelection,
        disabled: isDisabled,
        onChange: onChange,
        "data-t": "select-quantity"
    }));
};

export { SelectQuantity };
//# sourceMappingURL=SelectQuantity.js.map
